import React, {useContext, useEffect, useState} from "react";
import {getVendorAccounts} from "../../services/api/messaging";
import {AuthContext} from "../../context/AuthContext";
import {Card} from "flowbite-react";
import ConfirmationModal from "../../components/Modal/ConfirmationModal";
import ContactWrap from "../../components/Vendor/Contacts/ContactWrap";
import {
    getVendorContacts, getVendorContactsForPrimary,
    setVendorPrimaryAccount,
    vendorAddContact,
    vendorAddNewContact, vendorRemoveContact, vendorUpdateContact
} from "../../services/api/vendor";
import {
    ConsultantRelationsLeader,
    DemandGenerationLeader,
    MarketingLeader, PrimaryAdmin, RfiAdministrator,
    SalesLeader, SalesOperations
} from "../../services/constants/Vendor/VendorContacts";
import SuccessToaster from "../../components/Toasters/SuccessToaster";


const ContactsPage = () => {
    const [allVendorAccounts, setAllVendorAccounts] = useState(null);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [primaryConfirmModal, setPrimaryConfirmModal] = useState(false);
    const [vendorContacts, setVendorContacts] = useState(null);
    const [vendorContactsForPrimary, setVendorContactsForPrimary] = useState(null);
    const [isContactCreated, setIsContactCreated] = useState(false);
    const authData = useContext(AuthContext);

    const fetchVendorContacts = async () => {
        try {
            const contacts = await getVendorContacts();
            setVendorContacts(contacts);
            setDefaultSelectedContacts(contacts, false);
        } catch (error) {
            console.error('Error fetching vendor contacts:', error);
        }
    }

    const fetchVendorContactsForPrimary = async () => {
        try {
            const contacts = await getVendorContactsForPrimary(authData.company.id);
            setVendorContactsForPrimary(contacts);

        } catch (error) {
            console.error('Error fetching vendor contacts:', error);
        }
    }

    useEffect(() => {
        if (!vendorContactsForPrimary)
            fetchVendorContactsForPrimary().then(() => true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!vendorContacts && allVendorAccounts) {
            fetchVendorContacts().then(() => true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vendorContacts, allVendorAccounts]);

    useEffect(() => {
            const fetchAllVendorAccounts = async () => {
                if (allVendorAccounts) return;
                try {
                    const vendors = await getVendorAccounts(authData.company?.id);
                    setAllVendorAccounts(vendors);
                } catch (error) {
                    console.error('Error fetching vendor accounts:', error);
                }
            }

            if (!allVendorAccounts) {
                fetchAllVendorAccounts().then(() => true);
            }
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        [allVendorAccounts]);


    const getAccountById = (id) => {
        return allVendorAccounts.find(account => account.id === id);
    }

    const setDefaultSelectedContacts = (vendorContacts, adminOnly = false) => {
        const tempContacts = {};
        Object.keys(vendorContacts).map((key) => {
            if (key === 'primary')
                tempContacts.primaryAdmin = [getAccountById(vendorContacts[key].id)];
            else if (!adminOnly) {
                let tempAccounts = [];
                vendorContacts[key].contact?.map(contact => {
                    tempAccounts.push(getAccountById(contact.account_id));
                    return true;
                });
                tempContacts[key] = tempAccounts.length > 0 ? tempAccounts : [null];
            }
            return true;
        })

        setSelectedContacts({...selectedContacts, ...tempContacts});
    }

    const onChangePrimaryAdmin = (contact) => {
        setSelectedContacts({...selectedContacts, primaryAdmin: contact})
        setPrimaryConfirmModal(true)
    }

    const onPrimaryAdminCancel = () => {
        setPrimaryConfirmModal(false)
        setDefaultSelectedContacts(vendorContacts, true);
    }

    const onPrimaryAdminConfirm = async () => {
        try {
            await setVendorPrimaryAccount(authData.company.id, selectedContacts.primaryAdmin[0].id);
            await authData?.fetchAuthData();
            setPrimaryConfirmModal(false);
        } catch (error) {
            console.error('Error setting primary account:', error);
        }

    }

    const onUserCreated = async (user, type, prevAccount = null) => {
        try {
            setIsContactCreated(false);
            if (prevAccount) {
                //update contact
                const prevContact = vendorContacts[type].contact.find(contact => contact.account_id === prevAccount.id);
                await vendorAddNewContact(user.first_name, user.last_name, user.email, user.role, type, prevContact.id);
            } else
                await vendorAddNewContact(user.first_name, user.last_name, user.email, user.role, type);

            setIsContactCreated(true);
            setVendorContacts(null);
            setAllVendorAccounts(null);
            setSelectedContacts([]);
        } catch (error) {
            setIsContactCreated(false);
            return error;

        }
    }

    const onRemoveContact = async (userId, type) => {
        try {
            const selectedContact = vendorContacts[type].contact.find(contact => contact.account_id === userId);
            await vendorRemoveContact(selectedContact.id);
            await fetchVendorContacts();
        } catch (error) {
            console.error('Error removing contact:', error);
        }
    }

    const onContactSelect = async (allContacts, contact, type, prevId = false) => {
        try {
            if (contact && !prevId) {
                await vendorAddContact(authData.company.id, contact.id, type);
                await fetchVendorContacts();
            } else if (prevId && contact) {
                const prevContact = vendorContacts[type].contact.find(contact => contact.account_id === prevId);
                await vendorUpdateContact(prevContact.id, contact.id);
                await fetchVendorContacts();
            }
            setSelectedContacts({...selectedContacts, [type]: allContacts});
        } catch (error) {
            console.error('Error adding contact:', error);
        }
    }

    if (!allVendorAccounts || !vendorContactsForPrimary) {
        return <div className="sl-loader sl-m-auto"/>;
    }


    return (
        <div className="sl-container sl-m-auto sl-my-8 sl-h-full sl-mb-21 sl-text-left sl-flex sl-flex-col">
            {isContactCreated && <SuccessToaster label={"Contact created successfully!"}/>}

            {primaryConfirmModal && <ConfirmationModal
                title={`Confirm Primary Admin Reassignment`}
                message={<span
                    className={"sl-font"}>You're about to transfer your Primary Admin role to <span
                    className={"sl-text-gray-900 sl-font-semibold sl-text-md sl-font"}>{selectedContacts.primaryAdmin[0].username}</span>. This will give them full administrative control over the account.
                    Are you sure you want to proceed?</span>}
                btnConfirm={"Confirm Reassignment"}
                btnCancel={"Cancel"}
                handleConfirm={onPrimaryAdminConfirm}
                handleClose={onPrimaryAdminCancel}
            />}

            <span className={"sl-text-gray-900 sl-font-semibold sl-text-xxl sl-font"}>Key Contacts</span>
            <span className={"sl-text-gray-700 sl-font-normal sl-text-md sl-mb-8 sl-font"}>Please provide an assigned user for important situations such as consultant inquiries, employer leads or RFP requests.</span>

            <div className={"sl-w-full sl-flex sl-flex-col sl-gap-8"}>
                <Card className={"sl-shadow-none sl-border-gray-200"}>
                    <div className={"sl-w-full sl-flex sl-flex-col sl-gap-5"}>
                        <span className={"sl-text-gray-900 sl-font-semibold sl-text-24 sl-font"}>Primary Admin</span>
                        <ContactWrap
                            isPrimary={true}
                            contactType={PrimaryAdmin}
                            disabled={!authData.is_primary}
                            disabledText={"The primary admin cannot be changed. They can only reassign their role to someone else."}
                            skipCreate={true}
                            selectedContacts={selectedContacts}
                            onContactSelect={onChangePrimaryAdmin}
                            isMultiple={false}
                            accounts={vendorContactsForPrimary.filter(user => user.id !== authData.id)}/>

                    </div>
                </Card>

                <Card className={"sl-shadow-none sl-border-gray-200"}>
                    <div className={"sl-w-full sl-flex sl-flex-col sl-gap-5"}>
                        <span
                            className={"sl-text-gray-900 sl-font-semibold sl-text-24 sl-font sl-pb-20"}>Contacts</span>

                        <ContactWrap
                            contactType={ConsultantRelationsLeader}
                            onContactSelect={onContactSelect}
                            onRemoveContact={onRemoveContact}
                            onUserCreated={onUserCreated}
                            selectedContacts={selectedContacts}
                            isMultiple={false}
                            accounts={allVendorAccounts}/>

                        <ContactWrap
                            onContactSelect={onContactSelect}
                            onRemoveContact={onRemoveContact}
                            onUserCreated={onUserCreated}
                            contactType={SalesLeader}
                            isMultiple={false}
                            selectedContacts={selectedContacts}
                            accounts={allVendorAccounts}/>

                        <ContactWrap
                            onContactSelect={onContactSelect}
                            onRemoveContact={onRemoveContact}
                            onUserCreated={onUserCreated}
                            selectedContacts={selectedContacts}
                            contactType={MarketingLeader}
                            isMultiple={false} accounts={allVendorAccounts}/>

                        <ContactWrap
                            onContactSelect={onContactSelect}
                            onRemoveContact={onRemoveContact}
                            onUserCreated={onUserCreated}
                            selectedContacts={selectedContacts}
                            contactType={DemandGenerationLeader}
                            isMultiple={false} accounts={allVendorAccounts}/>

                        <ContactWrap
                            onContactSelect={onContactSelect}
                            onRemoveContact={onRemoveContact}
                            onUserCreated={onUserCreated}
                            selectedContacts={selectedContacts}
                            contactType={SalesOperations}
                            isMultiple={true} accounts={allVendorAccounts}/>

                        <ContactWrap
                            onContactSelect={onContactSelect}
                            onRemoveContact={onRemoveContact}
                            onUserCreated={onUserCreated}
                            selectedContacts={selectedContacts}
                            contactType={RfiAdministrator}
                            isMultiple={true} accounts={allVendorAccounts}/>

                    </div>
                </Card>
            </div>
        </div>
    );
}

export default ContactsPage;